import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonServiceService } from '../services/common-service.service';

@Component({
  selector: 'app-impact-stories',
  templateUrl: './impact-stories.component.html',
  styleUrls: ['./impact-stories.component.scss']
})
export class ImpactStoriesComponent implements OnInit {
  impactData: any = [];
  prevRoute = '';
  mainHead: any = [];
  isLoadMore = false;
  hideImpactData = true;

  constructor(private commonService: CommonServiceService, private router: Router) { }

  ngOnInit(): void {
    this.getimpactStoriesData();
    this.prevRoute = this.router.url;
    this.impactStoryPageHeading();
  }

  getimpactStoriesData(): void {
    this.commonService.impactStoriesData().subscribe(response => {
      if (response.success){
        this.impactData = response?.data;
      }
    });
  }

  impactStoryPageHeading(sectionId = 12): void {
    this.commonService.getPageDetails(sectionId).subscribe(res => {
      if (res.success){
        this.mainHead = (res.data ?? []).filter((item: { isActive?: boolean }) => item.isActive);
        if (!this.mainHead.length){
          this.hideImpactData = false;
        }

      }
    });
  }

}
